import React, { useEffect, useState } from "react";
import { CheckCircle2, AlertTriangle, ChevronDown } from "lucide-react";
import { api } from "@/lib/api";

/** Für Admin/Manager: welcher Coach hat Google verbunden – und wie viele Termine fehlen dort deshalb. */
export default function GoogleTeamCalendarStatus() {
  const [rows, setRows] = useState(null);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    api.get("/calendar/team-status").then((r) => setRows(r.data?.coaches || [])).catch(() => setRows([]));
  }, []);

  if (!rows || !rows.length) return null;
  const notConnected = rows.filter((r) => !r.connected);
  const missing = rows.reduce((s, r) => s + (r.connected ? 0 : r.missing_in_google), 0);

  return (
    <div className="border border-slate-200 bg-white" data-testid="gc-team-status">
      <button
        onClick={() => setOpen((v) => !v)}
        className="w-full px-4 py-3 flex items-center justify-between gap-3 text-left hover:bg-slate-50"
        data-testid="gc-team-status-toggle"
      >
        <span className="flex items-center gap-2 text-xs">
          {notConnected.length ? <AlertTriangle size={14} strokeWidth={1.5} className="text-amber-600" /> : <CheckCircle2 size={14} strokeWidth={1.5} className="text-emerald-600" />}
          <span className="font-medium text-slate-900">Google-Verbindung im Team</span>
          <span className="text-slate-500">
            {notConnected.length
              ? `${notConnected.length} Coach(es) ohne Verbindung · ${missing} Termine nicht in Google`
              : "alle verbunden"}
          </span>
        </span>
        <ChevronDown size={14} strokeWidth={1.5} className={`text-slate-400 transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <div className="border-t border-slate-100 divide-y divide-slate-100">
          {rows.map((r) => (
            <div key={r.user_id} className="px-4 py-2.5 flex items-center justify-between gap-3 text-xs" data-testid={`gc-team-row-${r.user_id}`}>
              <div className="min-w-0">
                <div className="text-slate-900 truncate">{r.name}</div>
                <div className="text-slate-400 truncate">{r.email}</div>
              </div>
              <div className="flex items-center gap-4 flex-shrink-0">
                <span className="text-slate-500">{r.upcoming} kommende Termine</span>
                {r.connected ? (
                  <span className="inline-flex items-center gap-1 text-emerald-700"><CheckCircle2 size={12} strokeWidth={1.5} /> verbunden</span>
                ) : (
                  <span className="inline-flex items-center gap-1 text-amber-800 bg-amber-50 border border-amber-200 px-2 py-1">
                    <AlertTriangle size={12} strokeWidth={1.5} /> nicht verbunden{r.missing_in_google ? ` · ${r.missing_in_google} Termine fehlen` : ""}
                  </span>
                )}
              </div>
            </div>
          ))}
          <div className="px-4 py-2.5 text-[11px] text-slate-500">
            Jeder Coach verbindet seinen eigenen Google-Kalender selbst unter „Termine“ – Termine landen immer nur im Kalender des zuständigen Coaches.
          </div>
        </div>
      )}
    </div>
  );
}
